module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (38).589ec5df.jpg";